import * as React from 'react';
import { observer } from 'mobx-react';
import strings from 'owa-strings/owa-options-strings';
import TimePicker from 'owa-timepicker/lib/components/TimePicker';
import formatEndTime from 'owa-timepicker/lib/utils/formatEndTime';
import { Label } from 'office-ui-fabric-react/lib/Label';
import getWorkingHoursStartTimeInMinutes from '../selectors/getWorkingHoursStartTime';
import getWorkingHoursEndTimeInMinutes from '../selectors/getWorkingHoursEndTime';
import getMinutesFromDisplayDate from '../utils/getMinutesFromDisplayDate';
import getDisplayDateFromMinutes from '../utils/getDisplayDateFromMinutes';
import isValidTimeSelection from '../utils/isValidTimeSelection';
import setWorkingHoursStartTimeOption from '../data/mutators/setWorkingHoursStartTimeOption';
import setWorkingHoursEndTimeOption from '../data/mutators/setWorkingHoursEndTimeOption';
import { getCalendarConfiguration } from 'owa-calendar-configuration';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
var styles = require('./WorkingHours.scss');
/**
 * Working hours component renders start time and end time
 */
export default observer(function WorkingHours() {
    var selectedStartTime = getDisplayDateFromMinutes(getWorkingHoursStartTimeInMinutes());
    var selectedEndTime = getDisplayDateFromMinutes(getWorkingHoursEndTimeInMinutes());
    var timeIncrement = getCalendarConfiguration().TimeIncrement;
    var timeFormat = getUserConfiguration() && getUserConfiguration().UserOptions.TimeFormat;
    /**
     * When users selects start time > end time then start/end time
     * values are updated with selected start time and user is shown a dialog message.
     * (The start time that you entered occurs after the end time. The end time must occur after the start time.)
     */
    var onStartTimeChange = function (startTimeDisplayDate) {
        var endTime = getWorkingHoursEndTimeInMinutes();
        var startTime = getMinutesFromDisplayDate(startTimeDisplayDate);
        setWorkingHoursStartTimeOption(startTime);
        if (!isValidTimeSelection(startTime, endTime)) {
            setWorkingHoursEndTimeOption(startTime);
        }
    };
    /**
     * When users selects end time < start time then start/end time
     * values are updated with selected end time and user is shown a dialog message.
     * (The end time that you entered occurs before the start time.The start time must occur before the end time.)
     */
    var onEndTimeChange = function (endTimeDisplayDate) {
        var endTime = getMinutesFromDisplayDate(endTimeDisplayDate);
        var startTime = getWorkingHoursStartTimeInMinutes();
        setWorkingHoursEndTimeOption(endTime);
        if (!isValidTimeSelection(startTime, endTime)) {
            setWorkingHoursStartTimeOption(endTime);
        }
    };
    var formatDuration = function (time) {
        return React.createElement("span", null, formatEndTime(time, selectedStartTime));
    };
    return (React.createElement("div", { className: styles.workingHoursWrapper },
        React.createElement(Label, null, strings.options_workingHoursLabel),
        React.createElement("div", { className: styles.timeWrapper },
            React.createElement("div", { className: styles.time },
                React.createElement(Label, null, strings.options_workingHours_workingHoursStartTime),
                React.createElement(TimePicker, { ariaLabel: strings.options_workingHours_workingHoursStartTime, selectedTime: selectedStartTime, minutesInterval: timeIncrement, onChanged: onStartTimeChange, userTimeFormat: timeFormat })),
            React.createElement("div", { className: styles.time },
                React.createElement(Label, null, strings.options_workingHours_workingHoursEndTime),
                React.createElement(TimePicker, { ariaLabel: strings.options_workingHours_workingHoursEndTime, selectedTime: selectedEndTime, formatDuration: formatDuration, minutesInterval: timeIncrement, onChanged: onEndTimeChange, startTime: selectedStartTime, userTimeFormat: timeFormat })))));
});
//# sourceMappingURL=WorkingHours.js.map